(function () {
  'use strict';
  if (!document.body.classList.contains('th-home')) return;
  var config = JSON.parse(document.getElementById('th-home-config').textContent);
  var strings = config.strings;
  var busy = false;
  var opening = null;
  var noticeTimer;
  var previousFocus;
  var currency = config.currency || 'USD';
  var formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency });
  var money = function (cents) { return formatter.format(cents / 100); };
  var route = function (path) { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || config.root || '/').replace(/\/?$/, '/') + path.replace(/^\//, ''); };
  var cards = new Map();
  var readCards = function () {
    document.querySelectorAll('[data-th-product-card]').forEach(function (card) {
      if (cards.has(card)) return;
      var data = JSON.parse(card.querySelector('[data-th-product]').textContent);
      var img = card.querySelector('.th-product-image');
      data.defaultImage = { src: img.getAttribute('src'), srcset: img.getAttribute('srcset') };
      cards.set(card, data);
      updateScent(card, data, currentVariant(card));
    });
  };
  function notice(message, persistent) {
    var box = document.querySelector('[data-th-notice]');
    clearTimeout(noticeTimer);
    box.textContent = message;
    box.hidden = false;
    if (!persistent) noticeTimer = setTimeout(function () { box.hidden = true; }, 4500);
  }
  function closeDialogs() {
    document.querySelectorAll('[data-th-dialog][open]').forEach(function (dialog) { dialog.close(); });
    document.body.style.overflow = '';
    if (previousFocus && previousFocus.isConnected) previousFocus.focus();
  }
  function openDialog(name) {
    closeDialogs();
    previousFocus = document.activeElement;
    var dialog = document.getElementById('th-' + name + '-dialog');
    if (!dialog) return;
    dialog.showModal();
    document.body.style.overflow = 'hidden';
  }
  async function getCart() {
    var response = await fetch(route('cart.js'), { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(strings.cart_error);
    var cart = await response.json();
    updateCount(cart.item_count);
    return cart;
  }
  function updateCount(count) {
    document.querySelectorAll('[data-th-count]').forEach(function (node) { node.textContent = String(count); node.hidden = !count; });
    document.querySelectorAll('[data-th-cart]').forEach(function (node) { node.setAttribute('aria-label', strings.open_bag + ', ' + count); });
  }
  function node(tag, className, text) {
    var el = document.createElement(tag);
    if (className) el.className = className;
    if (text !== undefined) el.textContent = text;
    return el;
  }
  function renderCart(cart) {
    var list = document.querySelector('[data-th-cart-lines]');
    list.replaceChildren();
    document.querySelector('[data-th-drawer-count]').textContent = '(' + cart.item_count + ')';
    document.querySelector('[data-th-cart-total]').textContent = money(cart.total_price);
    document.querySelector('[data-th-cart-summary]').hidden = !cart.item_count;
    if (!cart.item_count) {
      var empty = node('div', 'empty-cart');
      empty.append(node('p', '', strings.empty));
      var back = node('button', 'button button-primary', strings.continue);
      back.type = 'button'; back.dataset.thClose = ''; empty.append(back); list.append(empty); return;
    }
    cart.items.forEach(function (item) {
      var row = node('article', 'cart-line');
      var image = node('img'); image.src = item.image || ''; image.alt = item.product_title; image.width = 105; image.height = 105;
      var info = node('div');
      var link = node('a'); link.href = item.url; link.append(node('h3', '', item.product_title));
      info.append(link);
      if (item.variant_title && item.variant_title !== 'Default Title') info.append(node('p', '', item.variant_title));
      var controls = node('div', 'th-cart-quantity');
      [-1, 1].forEach(function (delta) {
        var button = node('button', '', delta < 0 ? '−' : '+');
        button.type = 'button'; button.dataset.thChangeKey = item.key; button.dataset.thQuantity = String(item.quantity + delta);
        button.setAttribute('aria-label', (delta < 0 ? strings.remove_one : strings.add_one) + ': ' + item.product_title);
        if (delta === 1) controls.append(node('span', '', String(item.quantity)));
        controls.append(button);
      });
      info.append(controls);
      var remove = node('button', 'th-cart-remove', strings.remove); remove.type = 'button'; remove.dataset.thChangeKey = item.key; remove.dataset.thQuantity = '0'; info.append(remove);
      row.append(image, info, node('strong', '', money(item.final_line_price))); list.append(row);
    });
  }
  async function openCart() {
    if (opening) return opening;
    closeDialogs();
    opening = (async function () {
      for (var attempt = 0; attempt < 30; attempt += 1) {
        if (typeof window.monster_refresh === 'function' && typeof window.monster_setCartItems === 'function' && typeof window.mu_productionAddToCartCallBack === 'function' && typeof window.openCart === 'function') {
          await window.monster_refresh(true);
          getCart().catch(function () {});
          return;
        }
        await new Promise(function (resolve) { setTimeout(resolve, 200); });
      }
      renderCart(await getCart());
      openDialog('cart');
    })().finally(function () { opening = null; });
    return opening;
  }
  function currentVariant(card) {
    var data = cards.get(card);
    var select = card.querySelector('[data-th-variant]');
    var id = Number(select ? select.value : card.dataset.thDefaultId);
    return data.variants.find(function (variant) { return variant.id === id; });
  }
  function updateScent(card, data, variant) {
    var scent = card.querySelector('[data-th-scent]');
    if (!scent || !variant) return;
    var index = (data.optionNames || []).findIndex(function (name) { return /scent|fragrance/i.test(name); });
    if (index >= 0 && Array.isArray(variant.options) && variant.options[index]) {
      scent.textContent = variant.options[index];
    }
  }
  function updateCard(card) {
    var data = cards.get(card);
    var variant = currentVariant(card);
    if (!variant) return;
    updateScent(card, data, variant);
    card.querySelector('[data-th-price]').textContent = money(variant.price);
    var button = card.querySelector('[data-th-add]');
    button.disabled = busy || !variant.available;
    button.dataset.thVariantId = String(variant.id);
    button.textContent = variant.available ? strings.add_to_bag + ' +' : strings.sold_out;
    button.setAttribute('aria-label', strings.add_to_bag + ': ' + data.title + ', ' + variant.title);
    card.querySelectorAll('[data-th-product-link]').forEach(function (link) { link.href = variant.url; });
    var img = card.querySelector('.th-product-image');
    if (variant.id === Number(card.dataset.thDefaultId) || !variant.image) {
      img.src = data.defaultImage.src;
      if (data.defaultImage.srcset) img.setAttribute('srcset', data.defaultImage.srcset);
    } else { img.removeAttribute('srcset'); img.src = variant.image; }
    var size = card.querySelector('[data-th-size]');
    var match = variant.title.match(/(\d+)\s*(?:fl\s*)?oz/i);
    if (size) size.textContent = match ? match[1] + ' fl oz' : card.dataset.thDefaultSize || '';
  }
  function lock(locked) {
    busy = locked;
    document.querySelectorAll('[data-th-variant]').forEach(function (select) { select.disabled = locked; });
    cards.forEach(function (_, card) { updateCard(card); });
  }
  async function addItems(items, button) {
    if (busy || !items.length || items.some(function (item) { return !Number.isSafeInteger(Number(item.id)) || Number(item.id) <= 0; })) return;
    var originalText = button.textContent;
    var posted = false;
    lock(true); button.disabled = true; button.setAttribute('aria-busy', 'true'); button.textContent = strings.adding;
    try {
      posted = true;
      var response = await fetch(route('cart/add.js'), { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({items:items}) });
      var result = await response.json();
      if (!response.ok) { posted = false; throw new Error(typeof result.description === 'string' ? result.description : strings.error); }
      if (!Array.isArray(result.items)) throw new Error(strings.uncertain);
      notice(strings.added);
      try { await openCart(); } catch (error) { notice(strings.drawer_error, true); }
    } catch (error) { notice(posted ? strings.uncertain : error.message || strings.error, true); }
    finally { lock(false); button.removeAttribute('aria-busy'); if (button.hasAttribute('data-th-kit')) { button.disabled = false; button.textContent = originalText; } }
  }
  async function changeQuantity(button) {
    if (busy) return;
    busy = true;
    document.querySelectorAll('[data-th-change-key]').forEach(function (control) { control.disabled = true; });
    try {
      var response = await fetch(route('cart/change.js'), { method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json',Accept:'application/json'}, body:JSON.stringify({id:button.dataset.thChangeKey,quantity:Number(button.dataset.thQuantity)}) });
      var cart = await response.json();
      if (!response.ok) throw new Error(cart.description || strings.error);
      updateCount(cart.item_count); renderCart(cart);
    } catch (error) { notice(error.message || strings.cart_error, true); }
    finally { busy = false; document.querySelectorAll('[data-th-change-key]').forEach(function (control) { control.disabled = false; }); }
  }
  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target : event.target.parentElement;
    if (!target) return;
    var add = target.closest('[data-th-add]');
    var kit = target.closest('[data-th-kit]');
    var bag = target.closest('[data-th-cart]');
    if (add || kit || bag) {
      event.preventDefault(); event.stopImmediatePropagation();
      if (bag) { openCart().catch(function () { notice(strings.cart_error, true); }); return; }
      if (add && !add.disabled) { var variant = currentVariant(add.closest('[data-th-product-card]')); if (variant && variant.available) addItems([{id:variant.id,quantity:1}],add); }
      if (kit && !kit.disabled) addItems(JSON.parse(kit.dataset.thItems),kit);
      return;
    }
    var open = target.closest('[data-th-open]'); if (open) { event.preventDefault(); openDialog(open.dataset.thOpen); return; }
    if (target.closest('[data-th-close]')) { event.preventDefault(); closeDialogs(); return; }
    var quantity = target.closest('[data-th-change-key]'); if (quantity) { event.preventDefault(); changeQuantity(quantity); return; }
    var review = target.closest('[data-th-review]');
    if (review) {
      var section = review.closest('.review-section');
      var data = JSON.parse(section.querySelector('[data-th-reviews]').textContent)[Number(review.dataset.thReview)];
      section.querySelector('blockquote').textContent = '“' + data.quote + '”';
      section.querySelector('.review-byline b').textContent = data.name;
      section.querySelector('.review-byline small').textContent = data.product;
      section.querySelector('.review-byline a').href = data.href;
      section.querySelectorAll('[data-th-review]').forEach(function (button) { button.classList.toggle('active', button === review); button.setAttribute('aria-pressed', String(button === review)); });
    }
    if (target.matches('[data-th-dialog]')) closeDialogs();
    document.querySelectorAll('.nav-dropdown[open]').forEach(function (dropdown) { if (!dropdown.contains(target)) dropdown.removeAttribute('open'); });
  }, true);
  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-th-variant]')) updateCard(event.target.closest('[data-th-product-card]'));
  });
  document.addEventListener('keydown', function (event) { if (event.key === 'Escape') { closeDialogs(); document.querySelectorAll('.nav-dropdown[open]').forEach(function (el) { el.removeAttribute('open'); }); } });
  document.addEventListener('shopify:section:load', function () { readCards(); });
  ['cart:updated','cart:refresh','monster:cart:updated'].forEach(function (event) { document.addEventListener(event, function () { getCart().catch(function () {}); }); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) getCart().catch(function () {}); });
  readCards();
  getCart().catch(function () {});
})();
